<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">

                        <div class="col-xl-12">                        

                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="row">
                                    <div class="col-lg-5 col-xs-12 col-xl-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisar:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Pesquise aqui.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 clearfix"></div> -->
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>                                                                                                                              

                                    <div class="col-lg-1 col-xs-2">
                                        <div class="submit-field" >
                                            <!-- <div class="hidden-xl hidden-lg hidden-md hidden-sm clearfix" v-if="$root.user.tipo == 'admin'" style="margin-top: 27px;"></div> -->
                                            <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray ">
                                                <i class="material-icons">search</i>
                                            </button>                                          
                                            <!-- <div class="hidden-xs hidden-xl hidden-md clearfix" style="margin-top: 10px;"></div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 

                            <div v-show="data.itens.length == 0 && data.itens.loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">
                                <h5 class="margin-bottom-10">{{data.total}} resultado(s) encontrado(s).</h5>
                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            Usuário
                                        </th>                                        
                                        <th style="min-width: 200px;">
                                            Detalhes
                                        </th>
                                        <!-- <th style="min-width: 150px; width: 150px;">
                                            Detalhes
                                        </th>   -->                                                                                                   
                                        <th style="min-width: 175px; width: 175px;">
                                            Data/hora
                                        </th>                                                                        
                                    </thead>
                                    <tbody>   
                                       
                                        <tr v-for="item in data.itens">
                                            <td data-label="ID">
                                                {{item.id}}
                                            </td>
                                            <td data-label="Usuário">
                                                <u>{{item.usuario ? item.usuario.nome : ''}}</u>
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'login'">
                                                Fez login
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'cadastrar'">
                                                Se cadastrou
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'conta_atualizar'">
                                                Atualizou os dados da conta
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'estoque_editar'">
                                                Editou o estoque <u>{{item.objetoAntes.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'estoque_movimentar'">
                                                Movimentou o estoque <u>{{item.objeto.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'estoque_cadastrar'">
                                                Cadastrou o estoque <u>{{item.objeto.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'estoque_apagar'">
                                                Apagou o estoque <u>{{item.objetoAntes.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'catalogo_editar_catalogo'">
                                                Editou o produto <u>{{item.objetoAntes.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'catalogo_cadastrar_catalogo'">
                                                Cadastrou o produto <u>{{item.objeto.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'catalogo_apagar_catalogo'">
                                                Apagou o produto <u>{{item.objetoAntes.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'catalogo_editar_premio'">
                                                Editou o prêmio <u>{{item.objetoAntes.nome}}</u> 
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'catalogo_cadastrar_premio'">
                                                Cadastrou o prêmio <u>{{item.objeto.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'catalogo_apagar_premio'">
                                                Apagou o prêmio <u>{{item.objetoAntes.nome}}</u>
                                            </td>       
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_pre_agendamento'">
                                                Fez um novo pré-agendamento de <u>{{item.objeto.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_venda'">
                                                Nova venda a granel de <u>{{item.objeto.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_editar'">
                                                Editou o abastecimento #{{item.objetoAntes.id}} de <u>{{item.objetoAntes.nome}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_cadastro'">
                                                Novo abastecimento de <u>{{item.objeto.nome}}</u> cadastrado
                                            </td>    
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_confirmar'">
                                                Confirmou o pré-agendamento <u>#{{item.objetoAntes.id}}</u>
                                            </td>        
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_finalizar'">
                                                Concluiu o abastecimento <u>#{{item.objetoAntes.id}}</u>
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_apagar'">
                                                Apagou o abastecimento <u>#{{item.objetoAntes.id}}</u>
                                            </td>                                                               
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_cancelar'">
                                                Cancelou o agendamento <u>#{{item.objetoAntes.id}}</u>
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'gamification_enviar'">
                                                Enviou o prêmio <u>{{item.objetoAntes.nome}}</u></b>
                                            </td>               
                                            <td data-label="Detalhes" v-if="item.tipo == 'gamification_entregar'">
                                                Entregou o prêmio <u>{{item.objetoAntes.nome}}</u></b>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'gamification_resgatar'">
                                                Solicitou o resgate do prêmio <u>{{item.objetoAntes.nome}}</u>
                                            </td>                                               
                                            <td data-label="Detalhes" v-if="item.tipo == 'senha_alterar'">
                                                Alterou a senha
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'senha_recuperacao_solicitar'">
                                                Solicitou recuperação de senha
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'senha_recuperacao_alterar'">
                                                Alterou a senha na recuperação de senha
                                            </td>   
                                            <td data-label="Detalhes" v-if="item.tipo == 'usuarios_apagar_contratante'">
                                                Apagou o usuário piloto <u>{{item.objetoAntes.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'usuarios_editar_contratante'">
                                                Editou o usuário piloto <u>{{item.objetoAntes.nome}}</u>
                                            </td>     
                                            <td data-label="Detalhes" v-if="item.tipo == 'usuarios_cadastrar_contratante'">
                                                Cadastrou o usuário piloto <u>{{item.objeto.nome}}</u>
                                            </td>    
                                            <td data-label="Detalhes" v-if="item.tipo == 'usuarios_apagar_prestador' || item.tipo == 'usuarios_apagar_gerencial'">
                                                Apagou o usuário <u>{{item.objetoAntes.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'usuarios_editar_prestador' || item.tipo == 'usuarios_editar_gerencial'">
                                                Editou o usuário <u>{{item.objetoAntes.nome}}</u>
                                            </td>     
                                            <td data-label="Detalhes" v-if="item.tipo == 'usuarios_cadastrar_prestador' || item.tipo == 'usuarios_cadastrar_gerencial'">
                                                Cadastrou o usuário <u>{{item.objeto.nome}}</u>
                                            </td>
                                            <td data-label="Detalhes" v-if="item.tipo == 'empresas_apagar'">
                                                Apagou a filial <u>{{item.objetoAntes.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'empresas_editar'">
                                                Editou a filial <u>{{item.objetoAntes.nome}}</u>
                                            </td>     
                                            <td data-label="Detalhes" v-if="item.tipo == 'empresas_cadastrar'">
                                                Cadastrou a filial <u>{{item.objeto.nome}}</u>
                                            </td>                                              
                                            <td data-label="Detalhes" v-if="item.tipo == 'clientes_apagar'">
                                                Apagou o cliente <u>{{item.objetoAntes.nome}}</u>
                                            </td>                
                                            <td data-label="Detalhes" v-if="item.tipo == 'clientes_editar'">
                                                Editou o cliente <u>{{item.objetoAntes.nome}}</u>
                                            </td>     
                                            <td data-label="Detalhes" v-if="item.tipo == 'clientes_cadastrar'">
                                                Cadastrou o cliente <u>{{item.objeto.nome}}</u>
                                            </td>                                              
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_agendamento'">
                                                Fez um novo agendamento
                                            </td>                 
                                            <td data-label="Detalhes" v-if="item.tipo == 'pedido_atrasar'">
                                                Notificou sobre atraso no agendamento <u>#{{item.objetoAntes.id}}</u>
                                            </td> 
                                            <td data-label="Detalhes" v-if="item.tipo == 'contato'">
                                                Entrou em contato: <u>{{item.objeto.mensagem}}</u>
                                            </td>   
                                            <td data-label="Detalhes" v-if="item.tipo == 'precos_especiais_editar'">
                                                Atualizou os preços especiais de <u>{{item.objeto.mes}}/{{item.objeto.ano}}</u> para <u>{{item.objeto.empresaNome}}</u>
                                            </td>                                                                                                                                      
<!--                                             <td data-label="Detalhes">
                                               
                                            </td>     -->                 
                                            <td data-label="Data/hora">
                                                <i class="material-icons">access_time</i>
                                                {{item.datahora | formatDate}}
                                            </td>
                                        </tr>  

                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>

                        </div>                                                
                    </div>

                </div>
            </div>
        </div>

        <Toolbar></Toolbar>


    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Logs',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1,
                "pesquisa":         "",
                "dataInicio":       "",
                "dataFinal":        "",
                "tipo":             ""
            }              
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },    
    methods: {
        get: function(load) {
            var self        = this;
            console.log("get()", self.form);
            
            if (load) loading.show();

            return new Promise(function(resolve, reject) {

                axios.get("api/logs.php", {params: self.form, db: "logs"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    if (load) loading.hide();
                    
                    resolve(response.data.result);

                    self.$root.scrollTop();

  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    
                    if (load) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        init: function() {
            var self = this;
            Promise.all([
                self.get()
            ]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            }); 

        }
    },
    beforeMount: function(e){
    },    
    created: function() {
        var self = this;

        loading.show();
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }           
    },
    mounted: function() {
        var self            = this;

    }    
}    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logs.vue